import { AssetConfig } from "../../../config/assets";
import { RestakeSolTokenPicker } from "../RestakeSolTokenPicker";
import { StakeFormShell } from "../StakeFormShell";
import { useRestakeSol } from "./useRestakeSol";

interface RestakeSolStrategyProps {
  config: AssetConfig;
  resetKey: string;
}

export const RestakeSolStrategy = ({ config, resetKey }: RestakeSolStrategyProps) => {
  const { stakeFormProps, tokenPickerProps } = useRestakeSol({ config, resetKey });

  return (
    <StakeFormShell
      {...stakeFormProps}
      inputTokenSelector={<RestakeSolTokenPicker {...tokenPickerProps} />}
    />
  );
};
